import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getMaxPoints, getLoyaltyLevel, LOYALTY_LEVELS, LOYALTY_ICONS, getMaxLevel } from '~models/loyalty';
import { actionCreators as PapaPointsActions } from '~redux/PapaPoints/actions';

export const useLoyalty = () => {
  const currentUser = useSelector(state => state.auth.currentUser);
  const dispatch = useDispatch();
  useEffect(() => {
    if (currentUser) {
      dispatch(PapaPointsActions.getLoyaltyLevels());
    }
  }, [dispatch, currentUser]);

  const { loyaltyLevels } = useSelector(state => state.papaPoints);
  const logged = useMemo(() => !!currentUser, [currentUser]);

  const level = getLoyaltyLevel(currentUser?.loyaltyLevel, loyaltyLevels);
  const levelName = LOYALTY_LEVELS[level?.level];
  const nextLevelName = LOYALTY_LEVELS[level?.level + 1];
  const icons = LOYALTY_ICONS[levelName];
  const maxPoints = getMaxPoints(loyaltyLevels, level);
  const maxLevel = getMaxLevel(loyaltyLevels);

  return {
    level,
    currentUser,
    logged,
    loyaltyLevels,
    icons,
    levelName,
    dispatch,
    maxPoints,
    nextLevelName,
    maxLevel
  };
};
